import React , {useRef} from 'react';
import "../styles/App.scss";
import "../styles/PagesStyles.scss";
import useHoverImg from "../hooks/useHoverImg";
import Typography from '@mui/material/Typography';

function About(){
    const imgRef = useRef(null);//don't fill in the useRef just yet

    const DEFAULTPIC = "/assets/images/ME-newheadshot-polaroid.png";
    const HOVERPIC = "/assets/images/mepic-bat-beret.png";

    const currentImg = useHoverImg(imgRef, DEFAULTPIC, HOVERPIC);

    return(
        <>
            <div className="Aboutpage-maincontent">
                <div className="About-text">
                    <Typography variant="h1">About Me</Typography>
                    <Typography variant="h2">Who am I?</Typography>
                    <Typography variant="body1">
                        Hello. I studied for a bachelors in film,
                        with  a focus in animation at first, eventually
                        finding a love for storyboarding, but illustration always stayed.
                        I continued my education into computer science, but my passion for art
                        never wavered so I focused on web development and human
                        computer interaction. Combining these two interests,
                        helped me create this website.
                    </Typography>
                </div>
                <div className="About-img-container">
                    <img
                        className="About-vis"
                        id="mepic"
                        ref={imgRef}
                        src={currentImg}
                        alt="self portrait"
                        />
                        <div className="tape tape-about-1"></div>
                        <div className="tape tape-about-2"></div>
                </div>
            </div>
        </>
    );
}

export default About;